export type State = UsersData;

export interface UsersData {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    userLoggedIn: boolean;
    /** For /logout */
    csrfToken: string;
    creationDateMillis: number;
}

const initialState: UsersData = {
    id: 0,
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    userLoggedIn: false,
    /** For /logout */
    csrfToken: '',
    creationDateMillis: 0,
};

export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';

export const updateUserData = (payload: UsersData) => ({
    type: UPDATE_USER_DATA,
    payload,
});

export default (state: State = initialState, action): State =>
    action.type === UPDATE_USER_DATA ? action.payload : state;
